import publicPage from './publicpage'
import testPage from './testpage'
import privatePage from './privatepage'
import pdfReport from './pdfReport'

export default {
  publicPage,
  testPage,
  privatePage,
  pdfReport,
  lang: 'Sprache',
  sv: 'Svenska',
  en: 'English',
  de: 'Deutsch',
  it: 'Italiano',
  yes: 'Ja',
  no: 'Nein',
  name: 'Name',
  last_name: 'Nachname',
  first_name: 'Vorname',
  email_pin: 'E-mail / PIN',
  customer_tag: 'Tag',
  method: 'Methode',
  end_date: 'Enddatum',
  change_end_date: 'Das Enddatum ändern',
  finished_date: 'Beendet',
  test_not_started: 'Nicht gestartet',
  test_started: 'Gestartet',
  test_finished: 'Beendet',
  report: 'Report',
  create_report: 'Profil generieren',
  create_teamprofile: 'Team-Profil generieren',
  create_teamreport: 'Team Bericht generieren',
  team_name: 'Team Name',
  report_type: 'Art des Reports',
  report_cost: 'Credit-Betrag',
  report_unsupported_testmethod: 'Nicht unterstützte Testmethode',
  name_required_feedback: 'Schreiben Sie bitte Ihren Namen',
  field_required_feedback: 'Pflichtfeld',
  participant: 'Teilnehmer',
  test: 'Tests',
  available_credits: 'Verfügbare Credits',
  norm_group: 'Normgruppe',
  save: 'Speichern',
  preview: 'Vorschau',
  save_randomize: 'Speichern & Randomisieren',
  save_ok_feedback: 'Die Information wurde gespeichert',
  delete: 'Löschen',
  reset: 'Zurücksetzen',
  cancel: 'Abbrechen',
  update: 'Aktualisieren',
  logo: 'Logo',
  questions: 'Fragen',
  question: 'Fragen',
  questionalternative: 'Antwort',
  errorMessage_server: 'Ein Fehler ist aufgetreten',
  example: 'Beispiel',
  pageNotFoundMessage: 'Seite nicht gefunden',
  folder: 'Mappe',
  image: 'Bild',
  number: 'Anzahl',
  swedish: 'Svenska',
  english: 'English',
  deutsch: 'Deutsch',
  select_a_language: 'Eine Sprache wählen',
  select_a_normgroup: 'Eine Normgruppe wählen',
  select_a_report: 'Einen Bericht wählen',
  clear: 'Filter entfernen',
  type_to_search: 'Suchwort eingeben',
  content: 'Inhalt',
  search: 'Suche',
  from: 'Von',
  to: 'Zu',
  amount: 'Summe',
  date: 'Datum',
  result: 'Ergebnisse',
  header: 'Überschrift',
  description: 'Beschreibung',
  text: 'Text',
  expert_report: 'Berichte',
  create_expert_report: 'Bericht generieren',
  team_report: 'Team-Profil',
  prevPage: 'Zurück',
  nextPage: 'Weiter'
}
